import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import TOTPSetup from '../TOTPSetupWizard';
import PublicPageLayout from "../../PublicPageLayout";
export default function MultiFactorEditPage() {
    return (_jsx(PublicPageLayout, { heading: "Multi Factor Authentication", maxWidth: '800px', children: _jsx(TOTPSetup, {}) }));
}
